// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3rpNQ","list":"styles_list__2rM3I"};